import React from 'react'
import useTranslation from 'next-translate/useTranslation'

export const Header = () => {
  const { t } = useTranslation('common')

  return (
    <div className='page-header profile-notifications__header'>
      <p>{t('Oglas uspješno poslat')}</p>
    </div>
  )
}
